import React, { useEffect, useState } from 'react';
import { HourglassIcon } from 'lucide-react';
const TOTAL_SECONDS = 15 * 60;
export function UrgencyBar() {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const minutes = Math.floor(remaining / 60);
  const seconds = remaining % 60;
  return <div className="w-full bg-coral text-cream" data-id="element-211" data-mp="2yx80xi5cdbfy">
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-2 px-4 py-2.5 text-center text-[11px] font-semibold uppercase tracking-[0.16em] sm:text-xs" data-id="element-212" data-mp="2u3naqc9zplrb">
        <HourglassIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-213" data-mp="2k6r1238cutl6" />
        <span data-id="element-214" data-mp="2k4nykjq0n7zk">La oferta de lanzamiento termina en</span>
        <span aria-live="off" className="tabular-nums" data-id="element-215" data-mp="2f64c8i7ifu6o">
          <strong className="text-base font-bold tracking-normal" data-id="element-216" data-mp="2b5swnju08k22">{String(minutes).padStart(2, '0')}</strong>
          <span className="mx-1 text-[10px] opacity-80" data-id="element-217" data-mp="1rxki0qu8dqov">min</span>
          <span className="opacity-60" data-id="element-218" data-mp="1rv7ve0dj2s5h">:</span>
          <strong className="ml-1 text-base font-bold tracking-normal" data-id="element-219" data-mp="1woapc9m7w3m7">{String(seconds).padStart(2, '0')}</strong>
          <span className="ml-1 text-[10px] opacity-80" data-id="element-220" data-mp="1i067t8ywhy50">seg</span>
        </span>
      </div>
    </div>;
}